
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60.152","height":"57.194"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 11436","d":"M30.086 0l9.3 18.813 20.767 3.036L45.11 36.505l3.557 20.685-18.581-9.765-18.6 9.765 3.558-20.689L0 21.849l20.785-3.036z","fill":"#74ce00"}})])
          )
        }
      }
    